export const DEFAULT_ROUTE = '/'
